import { HStack, Icon, Text } from "@chakra-ui/react";
import React from "react";
import { HiOutlineInformationCircle } from "react-icons/hi2";
import { useNavigate, useParams } from "react-router-dom";

import { Link } from "../../../components";
import { NOTIFICATION_VIEW_SLUGS } from "./AiInterviewerNotificationsNav";

type NotificationDisabledAlertProps = {
  notificationName: string;
};

/**
 * Info banner shown above a notification template editor when that
 * notification is turned off in Notification Settings. Matches the pattern
 * used on the Invitation SMS editor.
 */
const NotificationDisabledAlert: React.FC<NotificationDisabledAlertProps> = ({
  notificationName,
}) => {
  const { aiInterviewerId } = useParams<"aiInterviewerId">();
  const navigate = useNavigate();

  const handleClick = (): void => {
    if (!aiInterviewerId) return;
    navigate(
      `/ai-interviewer/${aiInterviewerId}/notifications/${NOTIFICATION_VIEW_SLUGS.notificationSettings}`,
      { replace: true }
    );
  };

  return (
    <HStack bg="gray.50" borderRadius="md" p={3} spacing={1} align="center">
      <Icon as={HiOutlineInformationCircle} boxSize="4" color="gray.500" />
      <Text fontSize="sm" color="gray.800">
        {notificationName} is off. To enable it, go to{" "}
        <Link
          as="button"
          type="button"
          color="blue.600"
          textDecoration="underline"
          onClick={handleClick}
        >
          Notification Settings
        </Link>
        .
      </Text>
    </HStack>
  );
};

export default NotificationDisabledAlert;
